/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Consumption cycle lifetime policy for a contract rate.
 */
export type CycleKind = typeof CycleKind[keyof typeof CycleKind];


export const CycleKind = {
  rolling: 'rolling',
  calendar: 'calendar',
} as const;
